export const mySchemeTab = {
    copySuccess: '复制链接成功，粘贴至微信或QQ即可分享',
    confirmDelete: '删除后不可找回，确定要删除吗',
    rename: '重命名',
    createProject: '创建项目',
    share: '分享方案',
    delete: '删除方案',
    name: '方案名称',
    projectNamePlaceHolder: '输入项目名称',
    timeRange: '时间范围',
    sortByTime: '按创建时间排序',
    sortByShare: '按分享时间排序',
    search: '搜索',
    modifiedTime: '修改时间：',
    modifiedName: '修改文件名称',
    inputNamePrompt: '请输入方案名称',
    maxLength: '最多输入30个字符',
    lastModified: ' 最后修改：',
    recovery: '恢复',
    noMore: '没有更多了',
};
